import { Colors } from "@sweatpals/react-ui-kit";

export const testimonialCardStyles = () => ({
	card: {
		display: 'flex',
		padding: '24px',
		flexDirection: 'column',
		alignItems: 'flex-start',
		gap: '24px',
		border: '1.5px solid #000',
		my: 0.5,
	},
	nameText: {
		color: Colors['#120E0D'],
		fontFamily: 'Integral CF',
		fontSize: '14px',
		fontStyle: 'normal',
		fontWeight: '700',
		lineHeight: 'normal',
		textTransform: 'uppercase'
	},
	ageAndJobText: {
		color: Colors['6D7275'],
		fontFamily: 'Montserrat',
		fontSize: '14px',
		fontStyle: 'normal',
		fontWeight: '400',
		lineHeight: 'normal',
	},
	text: {
		color: 'black',
		fontFamily: 'Montserrat',
		fontSize: '14px',
		fontStyle: 'normal',
		fontWeight: '500',
		lineHeight: '21px',
	},
	videoWrapper: {
		position: 'relative'
	},
	videoPlayButtonWrapper: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		color: "white",
		cursor: 'pointer',
	},
});
